export default __webpack_public_path__ + "static/NBC-Universal-a8c3f80a8f1c2bacafc86638d3f4bd64.png";